<!--
  AssignmentEditModal — 지정의 기한·인원 상한·메모 수정 (PUT /voucher/org/{org}/class-vouchers/{idx})
  · 도서·등급은 바꿀 수 없다(종료 후 재지정)
-->
<template>
  <a-modal :open="true" title="지정 수정" :sub="`${assignment.title} · ${gradeLabel(assignment.grade)}`" size="sm" @close="$emit('close')">
    <div class="p-form">
      <div class="p-field">
        <label class="p-field__label">등록 기한 <span class="p-field__req">*</span></label>
        <input v-model="form.register_until" type="date" class="p-input" :min="today" />
        <div class="p-field__hint">KST 기준 오늘 이후여야 합니다.</div>
      </div>
      <div class="p-field">
        <label class="p-field__label">인원 상한</label>
        <input v-model="form.max_registrations" type="number" min="1" step="1" class="p-input" placeholder="비우면 제한 없음" />
        <div class="p-field__hint">현재 등록 {{ assignment.registered_count == null ? 0 : assignment.registered_count }}명보다 작게 줄일 수 없습니다.</div>
      </div>
      <div class="p-field">
        <label class="p-field__label">메모</label>
        <input v-model.trim="form.memo" type="text" class="p-input" maxlength="200" placeholder="내부 메모 (선택)" />
        <div class="p-field__hint">비우고 저장하면 메모가 지워집니다.</div>
      </div>
      <div v-if="error" class="p-alert p-alert--err"><div class="p-alert__body">{{ error }}</div></div>
    </div>
    <template #foot>
      <a-btn kind="ghost" @click="$emit('close')">취소</a-btn>
      <a-btn kind="primary" :disabled="!form.register_until || saving" @click="save">{{ saving ? '저장 중...' : '저장' }}</a-btn>
    </template>
  </a-modal>
</template>

<script>
import AModal from '@/components/Pineapple/AModal.vue';
import ABtn from '@/components/Pineapple/ABtn.vue';
import { gradeLabel, todayKst, voucherError, voucherErrorText } from '../orgUtils';

export default {
  name: 'AssignmentEditModal',
  components: { AModal, ABtn },
  props: {
    orgIdx: { type: [Number, String], required: true },
    assignment: { type: Object, required: true },
  },
  emits: ['close', 'saved'],
  data() {
    return {
      form: {
        register_until: this.assignment.register_until ? String(this.assignment.register_until).slice(0, 10) : '',
        max_registrations: this.assignment.max_registrations == null ? '' : String(this.assignment.max_registrations),
        memo: this.assignment.memo || '',
      },
      saving: false,
      error: '',
      today: todayKst(),
    };
  },
  methods: {
    gradeLabel,
    async save() {
      this.saving = true;
      this.error = '';
      try {
        const max = parseInt(this.form.max_registrations, 10);
        // 서버 규칙(2026-09-22 확정): max_registrations 는 null 명시 = 상한 해제, 생략 = 변경 없음.
        // memo 는 "" 로 비우고 null·생략은 변경 없음. register_until 은 비울 수 없는 값(항상 보낸다).
        const data = {
          register_until: this.form.register_until,
          max_registrations: !Number.isNaN(max) && max > 0 ? max : null,
          memo: this.form.memo,
        };
        await this.$axios({
          method: 'put',
          url: `/voucher/org/${this.orgIdx}/class-vouchers/${this.assignment.idx}`,
          data,
          loadingBar: true,
        });
        this.$notifyVue({ type: 'success', title: '지정을 수정했습니다.' });
        this.$emit('saved');
      } catch (e) {
        const err = voucherError(e);
        if (err.code === 'CLASS_VOUCHER_LIMIT_BELOW_USED' && err.detail && err.detail.used != null) {
          this.error = '인원 상한은 현재 등록 수(' + err.detail.used + '명)보다 작게 줄일 수 없습니다.';
        } else {
          this.error = voucherErrorText(e, '지정을 수정하지 못했습니다.');
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_org.scss';
</style>
